import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';

export default class EncryptionGroupUIListener extends UIListener {

    constructor() {
        super();
    }

    public onDetailViewReady(context: DetailViewContext): void {
        let canAssignOtherUsers = context.genericObject.getObservable('CanAssignOtherUsers');

        if (canAssignOtherUsers() === false) {
            (context.getUIFactory('Name') as ControlFactory).isEnabled(false);
            (context.getUIFactory('AssignedUsers') as ControlFactory).isEnabled(false);
        }
    }
}

ComponentManager.setUIListener('EncryptionGroupUIListener', EncryptionGroupUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.EncryptionGroupUIListener', EncryptionGroupUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');